/* Site-wide header instant search (SoBooster-parity dropdown, Meilisearch-backed).
   Attaches to the theme's .search__input fields (desktop bar + mobile drawer).
   Layout copied from the SoBooster panel: product grid with the match bolded,
   prices with RRP strike, footer "bekijk alle resultaten" link to /search. */
(function () {
  var HOST = "https://ms-57eeeb258f7e-51367.lon.meilisearch.io";
  var KEY = "fa2b5d55e33a66f69be89a81f3a84bdeb4933ea3f3e8cf948975bec3d7c3e9a4";
  var INDEX = "products_nagelfraeser";
  if (HOST.indexOf("PLACEHOLDER") !== -1 || KEY.indexOf("PLACEHOLDER") !== -1) return;

  // Hybrid (semantic + keyword) search — matches multi-word / synonym / intent
  // queries that keyword-only misses. KEEP IN SYNC with config.py (SEMANTIC_RATIO,
  // SCORE_THRESHOLD, EMBEDDER). Requires the `semantic` embedder to exist on the
  // index — deploy sync + resync BEFORE pushing this theme, or search errors.
  var HYBRID = { semanticRatio: 0.6, embedder: "semantic" };
  var SCORE_THRESHOLD = 0.5;

  // The panel must never be blank. A cold search costs ~220ms (TLS + hybrid query), and a
  // blank dropdown for that long reads as "nothing is happening". These two lists are
  // STATIC, injected by theme_push, so they render on the FIRST keystroke with no network:
  // matching collections appear instantly and products drop in underneath when Meili
  // answers. Coolblue's pattern. See facet_config.POPULAR_SEARCHES.
  // Widget chrome, injected per locale from i18n/<locale>.py. See meili-collection.js.
  // ⚠ Declared with `var` and a hoisted function on PURPOSE: this file is ES5-style and
  // t() is called from handlers defined above this point in source order.
  // Same request-time locale switch as meili-collection.js. window.MEILI is set by the
  // section; the header include runs on every page, so it may have none — hence the guard.
  var _overrides = {};
  var _M = window.MEILI || {};
  // window.MEILI only exists on Meili collection/search pages; everywhere else (home, PDP,
  // cart) the header box must still find its language, or salonplus.dk searched the
  // DUTCH index. Shopify.locale is on every storefront page.
  var _locale = _M.locale || (window.Shopify && window.Shopify.locale) || "";
  var _loc = (_overrides && _locale && _overrides[_locale]) || null;
  if (_loc && _loc.index) INDEX = _loc.index;
  var UI = (_loc && _loc.ui) || {"pager_prev": "‹ Zurück", "pager_next": "Weiter ›", "unit_in": "in", "price": "Preis", "rating": "Bewertung", "no_reviews": "Keine Bewertungen", "soldout": "Ausverkauft", "filters": "Filter", "filter_heading": "Filtern", "clear_all_filters": "Alle Filter zurücksetzen", "filters_clear": "Filter zurücksetzen", "filters_close": "Filter schließen", "filters_none": "Keine Filter verfügbar.", "filter_remove": "Filter entfernen", "filter_named_remove": "Filter {label} entfernen", "rating_filter_remove": "Bewertungsfilter entfernen", "and_up": "und höher", "stars_aria": "{n} Sterne", "rating_aria": "{label} von 5 Sternen, {n} {reviews}", "review_one": "Bewertung", "review_other": "Bewertungen", "explain": "Erklärung", "toggle_facet": "{label} ein- oder ausklappen", "explain_about": "Erklärung zu {label}", "close": "Schließen", "range_from": "Von", "range_to": "Bis", "show_one": "1 Produkt anzeigen", "show_other": "{n} Produkte anzeigen", "count_one": "1 Produkt", "count_other": "{n} Produkte", "popular_searches": "Beliebte Suchbegriffe", "no_products_for": "Keine Produkte gefunden für", "view_all_results": "Alle {n} Ergebnisse ansehen für", "home": "Startseite", "collections": "Kollektionen", "search": "Suche", "js_required": "Filter benötigen JavaScript.", "sort": "Sortieren", "chosen_filters": "Ihre gewählten Filter", "no_filters_chosen": "Noch keine Filter gewählt.", "of_5_stars": "von 5 Sternen", "products": "Produkte", "results": "Ergebnisse", "recent_searches": "Zuletzt von Ihnen gesucht", "relevant_pages": "Relevante Seiten", "product_matches": "Passende Produkte", "breadcrumb": "Brotkrümelnavigation", "search_placeholder": "Suchen ...", "sort_recommended": "Empfohlen", "sort_relevance": "Relevanz", "sort_best_rated": "Beste Bewertung", "sort_price_asc": "Preis aufsteigend", "sort_price_desc": "Preis absteigend", "sort_newest": "Neueste"};
  function t(key, vars) {
    var out = (UI && UI[key]) || key;
    for (var name in (vars || {})) out = out.split("{" + name + "}").join(vars[name]);
    return out;
  }

  var _pop = [["Nagelfräser", "/collections/nagelfraeser"], ["Fußpflegekoffer", "/collections/fusspflegekoffer"], ["Arbeitshocker", "/collections/arbeitshocker"], ["Handstück", "/collections/nagelfraeser-handstueck"], ["Sterilisation", "/collections/sterilisation"]];
  var POPULAR = (_loc && _loc.popular) || (Object.prototype.toString.call(_pop) === "[object Array]" ? _pop : []);
  var _pages = [["5 Second Spray", "/collections/5-second-spray"], ["Abonnementprodukte", "/collections/abonnementprodukte"], ["Absaugungstechnik Nagelfräser", "/collections/absaugungstechnik-nagelfraeser"], ["ACTIV Staubbeutel", "/collections/activ-staubbeutel"], ["Alkohol", "/collections/alkohol"], ["Alle Kosmetikwagen", "/collections/alle-kosmetikwagen"], ["Arbeitshocker", "/collections/arbeitshocker"], ["Autoklaven", "/collections/autoklaven"], ["Barhocker", "/collections/barhocker"], ["Bestellt vor 14:30 Uhr, geliefert in 2 Tagen", "/collections/schnelle-lieferung-produkten"], ["Bestseller", "/collections/bestseller"], ["Busch (Orthofex) Pediküre Fräser", "/collections/busch-orthofex-pedikuere-fraeser"], ["Desinfektion", "/collections/desinfektion"], ["Drehstühle", "/collections/drehstuehle"], ["Ersatzteile & Gasdruckfedern", "/collections/ersatzteile-gasdruckfedern"], ["Exo Pediküre Fräser", "/collections/exo-pedikuere-fraeser"], ["Fräserset", "/collections/fraeserset"], ["Fußbadewannen", "/collections/fussbadewannen"], ["Fußpflegekoffer", "/collections/fusspflegekoffer"], ["Fußpflegekoffer Zubehör", "/collections/fusspflegekoffer-zubehoer"], ["Handauflage für Nagelstudio", "/collections/handauflage-fuer-nagelstudio"], ["Handgel", "/collections/handgel"], ["Handschuhe", "/collections/handschuhe"], ["Handschuhe Latex", "/collections/handschuhe-latex"], ["Handschuhe Soft-Nitril", "/collections/handschuhe-soft-nitril"], ["Handschuhe Solid-Nitril", "/collections/handschuhe-solid-nitril"], ["Handschuhe Vinyl", "/collections/handschuhe-vinyl"], ["Handstückspray", "/collections/handstueckspray"], ["Handtuchwärmer", "/collections/handtuchwarmer"], ["Hautzangen", "/collections/hautzangen"], ["Hocker Zubehör", "/collections/hocker-zubehoer"], ["Hygiene", "/collections/hygiene"], ["Individuelle Fräser", "/collections/individuelle-fraeser"], ["JSDA/ACTIV Handstück", "/collections/jsda-activ-handstueck"], ["Kommode auf Rollen", "/collections/kommode-auf-rollen"], ["Kosmetikstühle", "/collections/kosmetikstuehle"], ["Kosmetikwagen", "/collections/kosmetikwagen"], ["LED Lampen", "/collections/led-lampen"], ["Leuchten", "/collections/leuchten"], ["Lupenlampe Zubehör", "/collections/lupenlampe-zubehor"], ["Lupenleuchten", "/collections/lupenleuchten"], ["Luspada Pediküre Fräser", "/collections/luspada-pedikuere-fraeser"], ["Manikürelampen", "/collections/manikurelampen"], ["Manikürtisch", "/collections/manikuertisch"], ["Manikürtisch mit Absaugung", "/collections/manikuertisch-mit-absaugung"], ["Manikürtisch ohne Absaugung", "/collections/manikuertisch-ohne-absaugung"], ["Medisept Skalpelle", "/collections/medisept-skalpelle"], ["Nagel- & Fußpflege", "/collections/nagel-fusspflege"], ["Nagelfräser", "/collections/nagelfraeser"], ["Nagelfräser Handstück", "/collections/nagelfraeser-handstueck"], ["Nagelfräser Mit Batterie", "/collections/nagelfraeser-mit-batterie"], ["Nagelfräser Zubehör", "/collections/nagelfraser-zubehor"], ["Nagelknipser", "/collections/nagelknipser"], ["Nagelzangen", "/collections/nagelzangen"], ["Nagelzangen, Hautzangen & Nagelknipser", "/collections/nagel-und-hautzangen"], ["Nasstechnik Nagelfräser", "/collections/nasstechnik-nagelfraeser"], ["Orthofex Handstück", "/collections/orthofex-handstueck"], ["Orthofex Nagelfräser", "/collections/orthofex-nagelfraeser"], ["Orthofex Staubbeutel", "/collections/orthofex-staubbeutel"], ["Pediküre Fräser", "/collections/pedikuere-fraeser"], ["PodoMonium Fußpflegekoffer", "/collections/podomonium-fusspflegekoffer"], ["PodoMonium Handstück", "/collections/podomonium-handstueck"], ["PodoMonium Nagelfräser", "/collections/podomonium-nagelfraeser"], ["PodoMonium Pediküre Fräser", "/collections/podomonium-pedikuere-fraeser"], ["PodoMonium Staubbeutel", "/collections/podomonium-staubbeutel"], ["PodoMonium Vorderteil", "/collections/podomonium-vorderteil"], ["Professionelle Vapozone für Kosmetikbehandlungen", "/collections/vapozone-fuer-kosmetikstudios"], ["Promed Handstück", "/collections/promed-handstueck"], ["Promed Nagelfräser", "/collections/promed-nagelfraeser"], ["Promed Pediküre Fräser", "/collections/promed-pedikuere-fraeser"], ["Promed Staubbeutel", "/collections/promed-staubbeutel"], ["Ringlichter", "/collections/ringlichter"], ["Rollhocker", "/collections/rollhocker"], ["Saeyang Handstück", "/collections/saeyang-handstueck"], ["Saeyang Nagelfräser", "/collections/saeyang-nagelfraeser"], ["Salon Werkzeuge & Zubehör", "/collections/salon-werkzeuge-zubehor"], ["Salonmöbel", "/collections/salonmobel"], ["Sattelhocker", "/collections/sattelhocker"], ["Skalpelle", "/collections/skalpelle"], ["Sonstige Hygieneartikel", "/collections/sonstige-hygieneartikel"], ["Spray Nozzle", "/collections/spray-nozzle"], ["Sprühflüssigkeit", "/collections/spruehfluessigkeit"], ["Staubabsaugung für Nägel", "/collections/staubabsaugung-fuer-naegel"], ["Staubbeutel", "/collections/staubbeutel"], ["Steril Skalpelle", "/collections/steril-skalpelle"], ["Sterilisation", "/collections/sterilisation"], ["Sterilisationsbeutel für Autoklaven", "/collections/sterilisationsbeutel-fuer-autoklaven"], ["Sterilisatoren", "/collections/sterilisatoren"], ["Stuhlhusse Arbeitshocker", "/collections/stuhlhusse-arbeitshocker"], ["Stuhlhusse Arbeitshocker Samt", "/collections/stuhlhusse-arbeitshocker-samt"], ["Stuhlhusse Arbeitshocker Terry", "/collections/stuhlhusse-arbeitshocker-terry"], ["Swann Morton Skalpelle", "/collections/swann-morton-skalpelle"], ["Tischlampen", "/collections/tischlampen"], ["Trockentechnik Nagelfräser", "/collections/trockentechnik-nagelfraeser"], ["Ultraschallreiniger", "/collections/ultraschallreiniger"], ["Unsteril Skalpelle", "/collections/unsteril-skalpelle"], ["UV Lampen für Nägel", "/collections/uv-lampen-fuer-naegel"], ["Wasserdestilliergeräte", "/collections/wasserdestilliergerate"], ["Wimpernlampen", "/collections/wimpernlampen"], ["Zubehör für Autoklaven", "/collections/zubehor-fur-autoklaven"]];
  var PAGES = (_loc && _loc.pages) || (Object.prototype.toString.call(_pages) === "[object Array]" ? _pages : []);

  // Warm DNS + TLS to the Meili host now, so the first search does not pay for it.
  try {
    var pc = document.createElement("link");
    pc.rel = "preconnect"; pc.href = HOST; pc.crossOrigin = "";
    document.head.appendChild(pc);
  } catch (e) { /* a missing preconnect only costs latency */ }

  var RECENT_KEY = "meili_recent_searches";
  function recent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]").slice(0, 5); }
    catch (e) { return []; }                       // private window / blocked storage
  }
  function remember(q) {
    try {
      var list = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5)));
    } catch (e) { /* never break search over storage */ }
  }
  // Collections whose title contains the query. Local, so it costs nothing.
  function matchPages(q) {
    var n = q.toLowerCase(), out = [];
    for (var i = 0; i < PAGES.length && out.length < 5; i++) {
      if (PAGES[i][0].toLowerCase().indexOf(n) !== -1) out.push(PAGES[i]);
    }
    return out;
  }
  function linkList(cls, items) {
    return '<div class="' + cls + '">' + items.map(function (it) {
      return '<a class="ms-suggest" href="' + esc(it[1]) + '">' + esc(it[0]) + "</a>";
    }).join("") + "</div>";
  }
  function section(title, html) {
    return '<p class="ms-heading">' + esc(title) + "</p>" + html;
  }

  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  /* market-price:start (identical in meili-collection.js and meili-search.js; tests pin it) */
  // Which price field this page shows, and how it is written. One theme serves
  // salonplus.nl, .dk, .se and .fi, whose prices are different NUMBERS: Shopify's rounded
  // market prices, indexed by sync.py as price_<CC> (29 EUR is 222 kr, not 29 x rate).
  // ⚠ Never a EUR amount on a DKK/SEK page: a currency with no field gets no price at all.
  // No currency sign anywhere (Luca 2026-09-29): the market's own thousands separator and
  // always two decimals, the SAME string snippets/meili-price.liquid renders server-side.
  var _mpM = window.MEILI || {}, _mpS = window.Shopify || {};
  var _mpMarkets = {};
  var MARKET_PRICES = (_mpMarkets && typeof _mpMarkets === "object") ? _mpMarkets : {};
  var SHOP_CURRENCY = "EUR";
  var _mpSpace = ["SE", "FI"];
  var PRICE_COUNTRY = String(_mpM.country || _mpS.country || "").toUpperCase();
  var PRICE_CURRENCY = String(_mpM.currency || (_mpS.currency && _mpS.currency.active) || SHOP_CURRENCY).toUpperCase();
  var PRICE_ATTR = (function () {
    if (MARKET_PRICES[PRICE_COUNTRY] === PRICE_CURRENCY) return "price_" + PRICE_COUNTRY;
    if (PRICE_CURRENCY === SHOP_CURRENCY) return "price";
    for (var c in MARKET_PRICES) if (MARKET_PRICES[c] === PRICE_CURRENCY) return "price_" + c;
    return null;
  })();
  var COMPARE_ATTR = PRICE_ATTR && PRICE_ATTR.replace(/^price/, "compare_at");
  var PRICE_GROUP = (Object.prototype.toString.call(_mpSpace) === "[object Array]" &&
                     _mpSpace.indexOf(PRICE_COUNTRY) !== -1) ? " " : ".";
  function priceOf(h) { return PRICE_ATTR && h ? h[PRICE_ATTR] : null; }
  function compareOf(h) { return COMPARE_ATTR && h ? h[COMPARE_ATTR] : null; }
  function fmtPrice(v, wholeOnly) {
    if (v == null || v === "" || isNaN(Number(v))) return "";
    var group = function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, PRICE_GROUP); };
    if (wholeOnly) return group(Math.round(Number(v)));
    var cents = Math.round(Number(v) * 100), d = cents % 100;
    return group(Math.floor(cents / 100)) + "," + (d < 10 ? "0" : "") + d;
  }
  /* market-price:end */

  // Search analytics -> the store's GA4. The on-page gtag only configures the Ads tag
  // (GA4 runs inside Shopify's pixel sandbox, unreachable from here), so we add the GA4
  // destination ourselves — measurement id derived from the _ga_<ID> cookie (store-
  // portable), send_page_view:false so page views stay the pixel's job.
  var _ga4Configured = false;
  function track(name, params) {
    try {
      if (typeof window.gtag !== "function") {
        if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, params));
        return;
      }
      if (!_ga4Configured) {
        var m = document.cookie.match(/_ga_([A-Z0-9]+)=/);
        if (m) {
          // the on-page container only carries the Ads tag: load the GA4 container too,
          // then configure it (queued events flush once it arrives)
          var s = document.createElement("script");
          s.async = true;
          s.src = "https://www.googletagmanager.com/gtag/js?id=G-" + m[1];
          document.head.appendChild(s);
          window.gtag("config", "G-" + m[1], { send_page_view: false });
        }
        _ga4Configured = true;
      }
      window.gtag("event", name, params);
    } catch (e) { /* analytics must never break search */ }
  }

  var panel = document.createElement("div");
  panel.id = "ms-panel";
  document.body.appendChild(panel);
  var activeInput = null, timer = null, lastQ = "", trackTimer = null;

  function close() { panel.className = ""; panel.innerHTML = ""; activeInput = null; lastQ = ""; }

  function position(input) {
    var r = input.getBoundingClientRect();
    var width = Math.min(720, Math.max(r.width, window.innerWidth - 32));
    if (window.innerWidth > 760) width = Math.min(720, Math.max(r.width, 560));
    var left = Math.max(16, Math.min(r.left, window.innerWidth - width - 16));
    panel.style.top = (r.bottom + 8) + "px";
    panel.style.left = left + "px";
    panel.style.width = width + "px";
  }

  // Meili highlights the match; we ask for <b> tags (SoBooster bolds the match too).
  // Hybrid search orders by fused semantic+keyword similarity, and that ordering ignores
  // stock: "tabouret" returned 6 of 6 OUT OF STOCK while 115 in-stock matches existed, and
  // in-stock products scoring a perfect 1.0000 sat below out-of-stock ones scoring 0.73.
  // Ranking rules cannot fix that (they act on the keyword pipeline, not the fusion), so
  // we over-fetch and re-order here:
  //   1. buyable first          — never lead with something they cannot order
  //   2. then relevance          — bucketed to 3dp, so near-ties count as ties
  //   3. then bestseller_rank    — position in best-verkocht, revenue-ranked nightly
  // Step 3 is what fixes "wasunit": 151 hits whose top 6 all scored exactly 1.0000 and
  // were being broken alphabetically. It can never outrank a genuinely better match.
  var OVERFETCH = 24;
  function reorder(hits) {
    return hits.map(function (h, i) { return { h: h, i: i }; }).sort(function (a, b) {
      var av = (a.h.available ? 0 : 1) - (b.h.available ? 0 : 1);
      if (av) return av;
      var sa = Math.round((a.h._rankingScore || 0) * 1000);
      var sb = Math.round((b.h._rankingScore || 0) * 1000);
      if (sa !== sb) return sb - sa;
      var ra = a.h.bestseller_rank == null ? 99999 : a.h.bestseller_rank;
      var rb = b.h.bestseller_rank == null ? 99999 : b.h.bestseller_rank;
      if (ra !== rb) return ra - rb;
      return a.i - b.i;                       // stable: keep Meili's order
    }).map(function (x) { return x.h; }).slice(0, 6);
  }

  function fetchResults(q, input) {
    fetch(HOST + "/indexes/" + INDEX + "/search", {
      method: "POST",
      headers: { Authorization: "Bearer " + KEY, "Content-Type": "application/json" },
      body: JSON.stringify({
        q: q, limit: OVERFETCH,
        hybrid: HYBRID, rankingScoreThreshold: SCORE_THRESHOLD,
        showRankingScore: true,
        // one result per model, so 15 Gabbiano Porto colourways cannot take 4 of 6 slots.
        // Per-QUERY, not the index-wide distinctAttribute: a collection page must still
        // show every colourway.
        distinct: "model",
        attributesToRetrieve: ["title", "url", "image", "available", "bestseller_rank"]
          .concat(PRICE_ATTR ? [PRICE_ATTR, COMPARE_ATTR] : []),
        attributesToHighlight: ["title"],
        highlightPreTag: "<b>", highlightPostTag: "</b>"
      })
    }).then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) {
        if (q !== lastQ || activeInput !== input) return;   // stale response
        var total = data.estimatedTotalHits != null ? data.estimatedTotalHits : (data.totalHits || 0);
        render(q, reorder(data.hits || []), total, input);
        // one event per SETTLED query (not per keystroke) — zero-result queries included,
        // they're the most valuable signal
        clearTimeout(trackTimer);
        trackTimer = setTimeout(function () {
          track("meili_instant_search", { search_term: q, results_count: total });
          if (total) remember(q);        // only queries that actually found something
        }, 900);
      })
      .catch(function (e) { console.warn("[meili] instant search failed", e); });
  }

  function titleHTML(h) {
    var t = (h._formatted && h._formatted.title) || h.title;
    // _formatted comes back raw apart from our <b> tags — escape everything else
    return esc(t).replace(/&lt;b&gt;/g, "<b>").replace(/&lt;\/b&gt;/g, "</b>");
  }

  // What the panel shows with no network: matching collections while typing, or the
  // recent/popular lists when the box is empty. Rendered on the FIRST keystroke.
  function instantHTML(q) {
    var html = "";
    if (!q) {
      var r = recent();
      if (r.length) html += section(t("recent_searches"), linkList("ms-suggests",
        r.map(function (t) { return [t, "/search?q=" + encodeURIComponent(t)]; })));
      if (POPULAR.length) html += section(t("popular_searches"), linkList("ms-suggests", POPULAR));
      return html;
    }
    var pages = matchPages(q);
    if (pages.length) html += section(t("relevant_pages"), linkList("ms-suggests", pages));
    return html;
  }

  function openInstant(q, input) {
    var html = instantHTML(q);
    // ⚠ Only close when nothing is coming. close() nulls activeInput and lastQ, which the
    // stale-response guard in fetchResults reads — closing here while a query was in
    // flight made its response be discarded, so any search matching NO collection title
    // ("porto oranje", a model code) returned nothing at all. The products slot must
    // exist for every searchable query, even with no instant content above it.
    if (!q) { if (html) { panel.innerHTML = html; panel.className = "is-open"; position(input); }
              else { close(); } return; }
    panel.innerHTML = html + '<div id="ms-products"></div>';
    panel.className = "is-open";
    position(input);
  }

  function render(q, hits, total, input) {
    // Products land UNDER whatever is already on screen, so nothing jumps or blanks.
    var slot = document.getElementById("ms-products");
    if (!hits.length) {
      if (slot) { slot.innerHTML = section(t("product_matches"),
        '<p class="ms-empty">' + t("no_products_for") + ' <b>' + esc(q) + "</b></p>"); return; }
      close(); return;
    }
    var items = hits.map(function (h) {
      var price = priceOf(h), compare = compareOf(h);
      var rrp = compare && compare > price ? "<s>" + fmtPrice(compare) + "</s> " : "";
      // demoted, not hidden — someone searching a specific model should still find it
      var oos = h.available === false ? '<span class="ms-oos">' + t("soldout") + '</span>' : "";
      return '<a class="ms-item' + (h.available === false ? " is-oos" : "") + '" href="' + esc(h.url) + '">' +
        '<img src="' + esc(h.image || "") + '" alt="" loading="lazy">' +
        '<span class="ms-item-body"><span class="ms-item-title">' + titleHTML(h) + "</span>" +
        '<span class="ms-item-price">' + rrp + fmtPrice(price) + oos + "</span></span></a>";
    }).join("");
    var productsHTML = section(t("product_matches"),
      '<div class="ms-grid">' + items + "</div>" +
      '<a class="ms-all" href="/search?q=' + encodeURIComponent(q) + '">' +
      t("view_all_results", { n: total }) + " <b>" + esc(q) + "</b></a>");
    if (slot) { slot.innerHTML = productsHTML; }
    else { panel.innerHTML = instantHTML(q) + '<div id="ms-products">' + productsHTML + "</div>"; }
    panel.className = "is-open";
    position(input);
  }

  document.addEventListener("input", function (e) {
    if (!e.target.matches || !e.target.matches(".search__input, .mc-searchinput")) return;
    var input = e.target;
    var q = input.value.trim();
    clearTimeout(timer);
    activeInput = input; lastQ = q;
    if (q.length < 2) { openInstant("", input); return; }   // still shows recent + popular
    openInstant(q, input);                                   // instant, no network
    // 120ms not 220: the round trip is ~220ms on its own, and a stale-response guard in
    // fetchResults already discards anything that arrives out of order.
    timer = setTimeout(function () { fetchResults(q, input); }, 120);
  });

  // Empty box, focused: recent searches + popular terms, like Coolblue.
  document.addEventListener("focusin", function (e) {
    if (!e.target.matches || !e.target.matches(".search__input, .mc-searchinput")) return;
    activeInput = e.target;
    if (!e.target.value.trim()) openInstant("", e.target);
  });
  document.addEventListener("click", function (e) {
    if (!panel.className) return;
    var item = e.target.closest && e.target.closest("#ms-panel .ms-item");
    if (item) {   // beacon: the click navigates away immediately
      track("meili_instant_click", { search_term: lastQ, item_url: item.getAttribute("href"), transport_type: "beacon" });
      return;
    }
    if (e.target.closest && (e.target.closest("#ms-panel") ||
        e.target.matches(".search__input, .mc-searchinput"))) return;
    close();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  window.addEventListener("resize", function () { if (panel.className && activeInput) position(activeInput); });
  // Enter submits the surrounding form natively -> /search?q=...
})();
